export const InitiatePlaybackClientInformation = 'NativeModuleInterface.v1_0.InitiatePlaybackClientInformation';
